import React from 'react';
import { faFileContract } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

const RecapsWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  const groups = data.groups || [];
  return (
    <>
      {groups.length > 0 && (
        <div className="mydesk-groups">
          {groups.map((g) => (
            <span key={g.status} className="mydesk-group"><strong>{g.count}</strong> {g.label}</span>
          ))}
        </div>
      )}
      {items.length === 0 && <WidgetEmpty>No active recaps.</WidgetEmpty>}
      {items.map((r) => (
        <WidgetRow
          key={r.id}
          icon={faFileContract}
          tone="brand"
          title={r.partner_name || r.number}
          subtitle={[r.number, r.recap_type, r.commodity_label, r.laycan ? `Laycan ${r.laycan}` : ''].filter(Boolean).join(' · ')}
          right={(
            <>
              {r.stage_label && <Pill tone={r.stage_tone || 'info'}>{r.stage_label}</Pill>}
              <Age>{r.age_label}</Age>
            </>
          )}
          onClick={() => goTo(r.url)}
        />
      ))}
      <WidgetFooter label="Open Trade Operations" url={data.url} />
    </>
  );
};

export default RecapsWidget;
